import { Avatar, Skeleton } from 'antd'
import logo from '../../assets/forpy-logo.png'
import type { OnboardingProfile } from '../../helpers/OnboardingApi'
import * as S from './style'

export function OnboardingHeader ({ profile }: { profile?: OnboardingProfile }): React.ReactElement {
  const initials = profile?.name.trim().split(/\s+/).slice(0, 2).map(part => part[0]).join('').toUpperCase()
  return <S.Header>
    <img src={logo} alt='Forpy' />
    <div className='signed-in'>{profile ? <><Avatar size={30} src={profile.photo || undefined}>{initials}</Avatar><span>{profile.email}</span></> : <><Skeleton.Avatar active size={30} shape='circle' /><Skeleton.Input active size='small' style={{ width: 150 }} /></>}</div>
  </S.Header>
}
